interface ScpLogoProps {
  size?: number;
  className?: string;
}

export function ScpLogo({ size = 32, className = '' }: ScpLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <radialGradient id="scp-bg" cx="50%" cy="45%" r="55%">
          <stop offset="0%" stopColor="#1e293b" />
          <stop offset="100%" stopColor="#0f172a" />
        </radialGradient>
        <linearGradient id="scp-main" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#38bdf8" />
          <stop offset="100%" stopColor="#6366f1" />
        </linearGradient>
      </defs>
      <circle cx="256" cy="256" r="256" fill="url(#scp-bg)" />
      <circle cx="256" cy="256" r="218" fill="none" stroke="url(#scp-main)" strokeWidth="24" strokeLinecap="round" opacity="0.9" />
      <circle cx="256" cy="256" r="70" fill="none" stroke="url(#scp-main)" strokeWidth="14" strokeLinecap="round" opacity="0.8" />
      <circle cx="256" cy="256" r="20" fill="url(#scp-main)" />
      <circle cx="249" cy="249" r="6" fill="white" opacity="0.35" />
      {[0, 120, 240].map((angle) => (
        <g key={angle} transform={`rotate(${angle}, 256, 256)`}>
          <rect x="245" y="82" width="22" height="68" rx="11" fill="url(#scp-main)" />
          <rect x="248" y="146" width="16" height="16" rx="3" fill="url(#scp-main)" />
          <path d="M244,172 L256,214 L268,172 Q268,162 256,162 Q244,162 244,172 Z" fill="url(#scp-main)" />
          <line x1="256" y1="168" x2="256" y2="208" stroke="#0f172a" strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="256" cy="177" r="3.5" fill="#0f172a" />
          <circle cx="256" cy="214" r="4" fill="url(#scp-main)" />
        </g>
      ))}
      <g fill="url(#scp-main)" opacity="0.3">
        <circle cx="256" cy="30" r="7" />
        <circle cx="452" cy="130" r="5" />
        <circle cx="482" cy="256" r="7" />
        <circle cx="452" cy="382" r="5" />
        <circle cx="256" cy="482" r="7" />
        <circle cx="60" cy="382" r="5" />
        <circle cx="30" cy="256" r="7" />
        <circle cx="60" cy="130" r="5" />
      </g>
    </svg>
  );
}
